//import useCopyPasteBlocks from "./useCopyPasteBlocks";
import { useAtom } from "jotai";
import { selectionAtom } from "../../jotai/atoms";
import { useBlocks } from "../../liveblocks/maps";
import useKeyAction from "../../utils/useKeyAction";
import useCopyPasteBlocks from "./useCopyPasteBlocks";

export default function useSelectionKeyAction() {
  const { deleteBlock } = useBlocks();
  const [selection, setSelection] = useAtom(selectionAtom);

  useCopyPasteBlocks();

  useKeyAction([{ key: "Delete" }, { key: "Backspace" }], () => {
    if (Object.keys(selection).length > 0) {
      deleteBlock(...Object.keys(selection));
      setSelection({});
    }
  });

  useKeyAction({ key: "Escape" }, () => {
    setSelection({});
  });
}
